import React, { FC } from "react";
import {
  AssignmentsConfigFormBasicsDto,
  FormBaseType,
} from "@green0meter/api-client";
import { useTranslation } from "react-i18next";
import { IconButton, Typography } from "@mui/material";
import FeatherIcon from "feather-icons-react";
import { useNavigate } from "react-router-dom";

import { useUserStore } from "@store/user";
import { useGetQuestionsAssignmentFormsBasics } from "@api";
import { Chip, Table } from "@components/common";
import { TableColumn } from "@components/common/Table";
import { Box, Stack, Tooltip } from "@components/base";

const AssignableForms: FC = () => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const navigate = useNavigate();
  const {
    questionsAssignmentFormsBasics,
    isLoadingGetQuestionsAssignmentFormsBasics,
  } = useGetQuestionsAssignmentFormsBasics(user);

  const handleEdit = (formId: string): void => {
    navigate(`/question-assignment/${formId}`);
  };

  const columns: TableColumn<AssignmentsConfigFormBasicsDto>[] = [
    {
      title: t("questionsAssignment.columns.formTemplateName"),
      key: "name",
      dataKey: "name",
    },
    {
      title: t("questionsAssignment.columns.formBaseType"),
      key: "formBaseType",
      renderCellContent: (item) => (
        <Chip
          label={FormBaseType[item.formBaseType]}
          type="outlined"
          color="orange1"
          size="medium"
        />
      ),
    },
    {
      title: t("questionsAssignment.columns.assignableForms"),
      key: "assignedForms",
      renderCellContent: (item) => (
        <Stack spacing={1} direction="row">
          {item.assignedForms.length === 0 && (
            <Typography variant="body2" color="textSecondary" fontStyle={"italic"}>
              {t("questionsAssignment.noFormsAssigned")}
            </Typography>
          )}
          {item.assignedForms.map((a) => (
            <Chip
              key={a.id}
              label={a.name}
              type="outlined"
              color="blue1"
              size="medium"
            />
          ))}
        </Stack>
      ),
    },
    {
      title: t("common.actions"),
      key: "actions",
      renderCellContent: (item) => (
        <Tooltip title={t("common.edit")}>
          <IconButton
            onClick={() => handleEdit(item.id)}
            size="small"
            color="primary"
          >
            <FeatherIcon icon="edit" size={16} />
          </IconButton>
        </Tooltip>
      ),
      tableCellProps: {
        align: "center",
        width: 50,
      },
    },
  ];

  return (
    <Table<AssignmentsConfigFormBasicsDto>
      data={questionsAssignmentFormsBasics ?? []}
      isLoading={isLoadingGetQuestionsAssignmentFormsBasics}
      dataPlaceholder={
        <Box py={2}>
          <Typography variant="body1" color="textSecondary">
            {t("questionsAssignment.noFormsToAssign")}
          </Typography>
        </Box>
      }
      columns={columns}
    />
  );
};

export default AssignableForms;
